import { hasValue } from 'utils/values';

export function shouldProcessEvent(params: {
  gridSpecificationKey: string;
  currentProposalId: string | undefined;
  eventProposalId: string | undefined | null;
}) {
  const { gridSpecificationKey, currentProposalId, eventProposalId } = params;
  const isLive = gridSpecificationKey.includes('live');
  const isGlobal = !hasValue(eventProposalId);
  const isSameProposal =
    hasValue(currentProposalId) && hasValue(eventProposalId) && currentProposalId === eventProposalId;

  if (isLive) return isGlobal;

  return isGlobal || isSameProposal;
}

/** Paths: /projects/:projectId or /projects/:projectId/proposals/:proposalId */
const PROJECT_PROPOSAL_PATH_REGEX = /^\/projects\/([^/]+)(?:\/proposals\/([^/]+))?/;

export type ProposalRouteContext = {
  currentProposalId: string | undefined;
  key: string;
};

// Returns current proposal context from pathname (key is 'live' when not on a proposal route).
export function getProposalContextFromPathname(pathname: string): ProposalRouteContext {
  const match = pathname.match(PROJECT_PROPOSAL_PATH_REGEX);
  const currentProposalId = match?.[2];
  const key = currentProposalId ?? 'live';
  return { currentProposalId, key };
}

// Returns whether the event should be processed for the current route (pathname).
export function shouldProcessEventForCurrentRoute(
  pathname: string,
  eventProposalId: string | undefined | null
): boolean {
  const { currentProposalId, key } = getProposalContextFromPathname(pathname);
  return shouldProcessEvent({
    gridSpecificationKey: key,
    currentProposalId,
    eventProposalId
  });
}
